// extracted by mini-css-extract-plugin
export default {"emptyMessagesContainer":"styles_emptyMessagesContainer__nGKqa","createSession":"styles_createSession__3baAf"};